import React from 'react';
import { Map } from 'immutable';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import classNames from 'classnames';
import EditableRTECell from 'main/components/show/cuesheet/editableRTECell.jsx';
import CellHistoryIcon from 'main/components/show/cuesheet/cellHistoryIcon.jsx';
import FDTPropUpdateFixMixin from 'main/components/show/cuesheet/FDTPropUpdateFixMixin';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import { appendTextToRTEState } from 'shared/lib/rteHelper';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';

/**
 * Segment editable cell
 *
 */
export default React.createClass({
  displayName: 'ItemSegmentCell',

  mixins: [FDTPropUpdateFixMixin, HighlightCellMixin],

  propTypes: {
    item: React.PropTypes.any.isRequired,
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    isTitleCopied: React.PropTypes.bool,
    rowIndex: React.PropTypes.number.isRequired,
    displayType: React.PropTypes.string,
    rowId: React.PropTypes.string,
    rowType: React.PropTypes.string,
    corrupted: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      isEditing: false,
      isSelected: false,
      placeholder: '',
    };
  },

  render() {
    const {
      isSelected,
      isEditing,
      isTracked,
      isCopied,
      partialCell,
      placeholder,
      rowIndex,
      itemCollabCell,
      rowId,
      title,
      titleFormat,
      titleView,
    } = this.props;

    let historyNode = null;

    const cellSpec = Map({
      type: EditableCellTypes.ItemTitle,
      value: EditableCellTypes.ItemTitle,
    });

    if (isSelected && !isEditing) {
      historyNode = (
        <CellHistoryIcon
          onClick={() =>
            CuesheetCellActions.showCellHistory(rowIndex, cellSpec)
          }
        />
      );
    }

    let titleRowClass = titleView ? 'cs-title-cell' : null;

    let className = classNames('cs-segment-cell', titleRowClass, {
      'cs-cell-copied': isCopied,
    });

    let rteState = this._getCellState();

    if (rteState && !isEditing) {
      if (!title) {
        //Just checking the blocks for text doesn't test whether there is no text but an entity (image, etc)
        rteState = appendTextToRTEState(rteState, placeholder);
      }
    }

    const globalHighlightStyle = isTracked
      ? {}
      : this.getGlobalHighlightStyle();
    const collabStyle = HighlightCellHelper.getCollabBorderStyle(
      itemCollabCell,
    );

    let format = titleFormat;

    //Don't use backColor formatting on the cell if we're tracking
    if (isTracked && titleFormat) {
      format = format.delete('backColor');
    }

    return (
      <div>
        {historyNode}
        <EditableRTECell
          format={format}
          onSelect={this._select}
          onStartEdit={this._startEditing}
          onStopEdit={this._stopEditing}
          rteState={rteState}
          resizeWhenEditing
          extraClassName={className}
          allowMarkdown
          partialCell={partialCell}
          placeholder={placeholder}
          collabCell={itemCollabCell}
          style={Object.assign({}, globalHighlightStyle, collabStyle)}
          rowId={rowId}
          {...this.props}
        />
      </div>
    );
  },

  _getCellState() {
    return this.props.item.get('rteTitleState');
  },

  _select() {
    CuesheetCellActions.selectItemCell(
      this.props.rowIndex,
      EditableCellTypes.ItemTitle,
    );
  },

  _startEditing() {
    CuesheetCellActions.startEditingItemCell(
      this.props.rowIndex,
      EditableCellTypes.ItemTitle,
    );
  },

  _stopEditing(rteState, rowId) {
    const cellSpec = Map({
      type: EditableCellTypes.ItemTitle,
      value: EditableCellTypes.ItemTitle,
    });

    CuesheetCellActions.saveDataCellChanges(rowId, cellSpec, rteState);
  },
});
